







import { Component, Vue } from 'vue-property-decorator';
import Header from '@/components/Base/Header.vue';
import { mapActions } from 'vuex';

@Component({
  components: {
    Header,
  },
  methods: {
    ...mapActions(['setPageLanguage']),
  },
})
export default class App extends Vue {
  private setPageLanguage!: any;

  private created() {
    this.setPageLanguage({lang: null, i18n: this.$i18n});
  }
}
